import React, { ReactElement } from 'react';
import { Header } from '../shared/header/header';

export const PowerBI = (): ReactElement => {
	return <Header title="Power BI" />;
};
